/**
 * Centralized Project Management Status Derivation Utilities.
 * Reusable across Job, Task, and Project configurations/hooks.
 */

export function deriveJobStatus(startDate, isCompleted, currentStatus) {
  const normalized = String(currentStatus || '').trim().toUpperCase()
  if (normalized === 'CLOSED') return 'CLOSED'
  // Crucial: preserve PENDING_REVIEW awaiting approval
  if (normalized === 'PENDING_REVIEW') return 'PENDING_REVIEW'
  if (Number(isCompleted || 0) === 1) return 'COMPLETED'
  if (normalized === 'COMPLETED') return 'COMPLETED'
  if (['ON_HOLD', 'CANCELLED'].includes(normalized)) return normalized

  if (!startDate) return 'DRAFT'
  const start = new Date(startDate)
  if (Number.isNaN(start.getTime())) return 'DRAFT'
  const today = new Date()
  const todayMid = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const startMid = new Date(start.getFullYear(), start.getMonth(), start.getDate())
  return startMid <= todayMid ? 'IN_PROGRESS' : 'DRAFT'
}

/**
 * Returns true ONLY if referenceDate > endDate (strictly overdue).
 * On the deadline day itself (today == endDate), returns false.
 */
export function isDateStrictlyOverdue(endDate, referenceDate = new Date()) {
  if (!endDate) return false
  const end = new Date(endDate)
  if (Number.isNaN(end.getTime())) return false
  const endMid = new Date(end.getFullYear(), end.getMonth(), end.getDate())
  const todayMid = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate())
  return todayMid > endMid
}

export function deriveTaskStatus(startDate, isCompleted, currentStatus, endDate, allJobsCompleted = false) {
  const normalized = String(currentStatus || '').trim().toUpperCase()
  if (normalized === 'CLOSED') return 'CLOSED'
  if (Number(isCompleted || 0) === 1 || normalized === 'COMPLETED') return 'COMPLETED'
  if (allJobsCompleted && isDateStrictlyOverdue(endDate)) return 'COMPLETED'
  if (['ON_HOLD', 'CANCELLED'].includes(normalized)) return normalized

  if (!startDate) return 'DRAFT'
  const start = new Date(startDate)
  if (Number.isNaN(start.getTime())) return 'DRAFT'
  const today = new Date()
  const todayMid = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const startMid = new Date(start.getFullYear(), start.getMonth(), start.getDate())
  return startMid <= todayMid ? 'IN_PROGRESS' : 'DRAFT'
}

